import { render, staticRenderFns } from "./Chatgpt.vue?vue&type=template&id=3e67bcfe&scoped=true"
import script from "./Chatgpt.vue?vue&type=script&lang=js"
export * from "./Chatgpt.vue?vue&type=script&lang=js"
import style0 from "./Chatgpt.vue?vue&type=style&index=0&id=3e67bcfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e67bcfe",
  null
  
)

export default component.exports